export default "__VITE_ASSET__5c854b5e__"